// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__IRAlu","on":"Switch_on__bsrz1","switch":"Switch_switch__ehvnj"};